import Login from './Login.jsx';

export default Login;



// WEBPACK FOOTER //
// ./src/components/modules/login/index.js